function e(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (r) {
    if ("default" !== r) {
      var o = Object.getOwnPropertyDescriptor(e, r);
      Object.defineProperty(t, r, o.get ? o : {
        enumerable: !0,
        get: function get() {
          return e[r];
        }
      });
    }
  }), t.default = e, t;
}

var t = e(require("react")),
    r = function r() {},
    o = t.createContext({
  value: !1,
  enable: r,
  disable: r,
  toggle: r
});

"production" !== process.env.NODE_ENV && (o.displayName = "DarkModeContext");
var n = t.createContext(void 0);
"production" !== process.env.NODE_ENV && (n.displayName = "ThemeStorageContext"), exports.DarkModeContext = o, exports.ThemeStorageContext = n, exports.useDarkMode = function () {
  return t.useContext(o);
};